import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/snapchat-ghost': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M510.8 392.7C505.6 404.8 483.6 413.8 443.5 420 441.4 422.8 439.7 434.7 437 443.9 435.4 449.5 431.4 452.8 424.9 452.8L424.6 452.8C415.2 452.8 405.4 448.5 385.7 448.5 359.2 448.5 350 454.5 329.4 469.1 307.6 484.5 286.7 497.8 255.4 496.5 223.8 498.8 197.4 479.6 182.6 469.1 161.8 454.4 152.7 448.5 126.3 448.5 107.4 448.5 95.6 453.2 87.5 453.2 79.4 453.2 76.2 448.3 75 444.2 72.3 435 70.6 422.9 68.5 420 47.8 416.8 1.2 408.7 0 387.9A10.6-10.6 0 0 0 8.9 376.8C78.5 365.4 109.8 293.9 111.1 290.9 111.2 290.7 111.3 290.5 111.4 290.4 115.1 282.8 115.9 276.5 113.8 271.6 108.8 259.7 86.9 255.5 77.8 251.8 54 242.5 50.8 231.7 52.2 224.3 54.6 211.5 73.9 203.6 85.2 208.9 94.1 213 102 215.2 108.7 215.2 113.7 215.2 116.9 214 118.7 213 116.6 177.1 111.6 125.7 124.3 97 158.1 21.3 229.7 15.4 250.8 15.4 251.8 15.4 260 15.3 260.9 15.3 313.1 15.3 363.2 42.1 387.7 97 400.4 125.6 395.4 176.8 393.4 213 394.9 213.9 397.7 214.9 402 215.1 408.4 214.8 415.8 212.7 424 208.9 430.1 206 438.4 206.4 444.5 208.9L444.5 208.9C454 212.3 460 219.1 460.1 226.8 460.3 236.6 451.6 245 434.2 251.8 432.1 252.7 429.5 253.5 426.8 254.3 417 257.5 402.2 262.2 398.2 271.6 396.1 276.5 396.9 282.8 400.7 290.4 400.7 290.5 400.8 290.7 400.9 290.9 402.2 293.9 433.5 365.3 503.1 376.8 509.5 377.9 514.3 384.7 510.8 392.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/snapchat-ghost.js
// module id = PA3W
// module chunks = 144